import { Check } from "lucide-react";
import { useIntl } from "react-intl";

import {
  DataFormToolbarButton,
  DataFormToolbarLayout,
} from "../../../../../data-form";
import { useDataFormPreferencesContext } from "../../context";
import { useApplyPreferenceProfile } from "../../hooks/apply-preference-profile";
import { parsePreferenceSettings } from "../../utils";
import { DataFormPreferencesToolbarCancelButton } from "./data-form-toolbar-cancel-button";
import { DataFormPreferencesSaveButton } from "./data-form-toolbar-save-button";

export function DataFormPreferenceApplyButton() {
  const intl = useIntl();
  const { setMode } = useDataFormPreferencesContext();

  return (
    <DataFormToolbarButton
      icon={{ Icon: Check }}
      tooltip={intl.formatMessage({
        id: "data-table.preferences.apply-profile",
        defaultMessage: "Použít nastavení",
      })}
      onClick={() => setMode("apply")}
    />
  );
}

export function DataFormPreferenceApplyAction() {
  const applyPreferenceProfile = useApplyPreferenceProfile();
  const { entity, setMode } = useDataFormPreferencesContext();

  if (!entity) {
    return null;
  }

  return (
    <DataFormToolbarLayout>
      <DataFormPreferencesToolbarCancelButton />

      <DataFormPreferencesSaveButton
        onClick={() => {
          if (entity.settings) {
            const settings = parsePreferenceSettings(entity.settings);
            void applyPreferenceProfile(
              { id: entity.id, name: entity.name },
              settings,
            );

            setMode("detail");
          }
        }}
      />
    </DataFormToolbarLayout>
  );
}
